// extracted by mini-css-extract-plugin
export default {"paymentPop":"Payment_paymentPop__eF-dt"};